// extracted by mini-css-extract-plugin
module.exports = {"floatingBackButton":"A1kx2","visible":"CmKki","hidden":"_3cKEo","headerBackButton":"_3bq6z","headerTitle":"_1Fl1t","scrollTriggeredHeader":"NYTbw"};